export const privacyPolicyData = {
  header_section: {
    page_title: "",
    page_title_highlighted: "Hot tips for Candidates",
    demo_section_title: "How to complete your",
    demo_section_title_highlighted: "First Interview",
    video_url:
      "http://webprojects.cloud/wordpress/predictivehire/wp-content/uploads/2020/05/Sapia_LiveInterview.mp4",
    demo_label: "",
    breadcrums: [
      {
        label: "< Back",
        link: "https://cx.predictivehire.com/sldkfjsdfsf",
      },
      {
        label: "FirstInterview Explainer",
        link: "/candidate-explainer/",
      },
    ],
    back_link_label: "",
    back_link: "",
  },
  contact_section: {
    section_title:
      "For any assistance with your FirstInterview please contact our support team.",
    button_label: "help",
    button_url: "",
    button_type: "true",
    privacy_button_label: "See the Explainer here >",
    privacy_button_link: "/candidate-explainer",
    privacy_button_type: "true",
  },
  main_section: [
    {
      section_type: "4",
      section_content: `<h2><strong>Privacy Policy</strong></h2>
      <h3>Welcome!</h3>
      <p>We are <strong>Sapia Pty Ltd </strong>trading as <strong>Sapia </strong>– our company details and
        our registration with the UK’s data protection regulator are available <a target="_blank"
          href="https://ico.org.uk/ESDWebPages/Entry/ZA899033">here</a>.</p>
      <ul class="this-page-list">
        <li><strong>This notice applies to you if</strong> we’ve contacted you about Sapia (including to provide
          you with a demo), you’re one of our corporate customers, or you’re browsing our website.</li>
        <li><strong>This notice does not apply to you if</strong> you are applying for a job with one of our clients and who
          use our interview platform. In these circumstances we will be acting as a processor of your personal data and we
          recommend you contact the organisation you’ve applied for a role with to find out more. Though if you have any
          questions and would rather ask us, of course we’ll do our best to help.</li>
      </ul>
      <p>We derive patterns from the free-text answers given by candidates during the interview process. Rather than just
        matching keywords, our technology reads, deciphers, understands and makes sense of answers. You can find out more
        about the AI in our platform <a target="_blank" href="https://www.predictivehire.com/science-explained/">here</a>.</p>
      <p>If you have any questions about this privacy notice, including any requests to exercise your legal rights, please
        contact us at privacy@predictivehire.com.</p>
      <p>If you are based in the EU, our EU Representative is Prighter, whose details are available <a target="_blank"
          href="https://prighter.com/q/14328687263">here</a>.</p>
      <h3>How do we use your data?</h3>
      <p>
        <ul class="this-page-list">
          <li><strong>When you create an account as an employer on our platform </strong>we will primarily take information
            about your organisation – we may however collect details of your point of contact at your organisation. This will
            be limited to name, company email and company telephone number. We do this in order to perform our obligations
            under the contract between us.<em>Whilst we will provide feedback on candidates after they have undertaken an
              interview on our platform, we do this in our capacity as a data processor, and you as the potential recruiter,
              are the data controller of any recruitment data shared.</em></li>
          <li><strong>When you book a personalised online demo to see how our platform works</strong> we will collect your
            name, work email, mobile phone, organisation name, job title and any additional info you provide to us when you
            reach out. We collect this under our legitimate interests to respond to your query as well as potentially take
            steps to enter into a contract with you.</li>
          <li>&nbsp;<strong>When you attend one of our events or a third party event. </strong>When you attend one of our
            events or a third party event, we may collect your personal information including your name, address, email
            address and phone number. We collect this information because it’s in our legitimate interests to know who’s
            attending our events and to help promote our business at third party events.</li>
          <li><strong>When you contact us. </strong>When you contact us either by phone, email, via social media (e.g. on
            LinkedIn) or via our email(<a href="mailto:support@predictivehire.com">support@predictivehire.com</a>) page with
            general queries, we
            will usually collect your name, social media handle and contact details, because it’s in our legitimate interest
            to make sure we can properly respond to your query.</li>
          <li><strong>When you receive our news updates. </strong>We will handle your personal information (such as your name
            and email address) to provide you with our news updates in line with any preferences you have told us about. Our
            clients are primarily businesses or individuals acting in their professional capacity therefore when we send you
            our news updates emails, we do this because of our legitimate interest to promote our business.You can unsubscribe
            from our updates at any time by clicking the unsubscribe link at the bottom of any of our emails, by emailing
            privacy@predictivehire.com.</li>
          <li>&nbsp;<strong>Technical information when you use our website</strong>. When you consent, we collect information
            about how you use our website. We use this information to improve our website and to better understand how people
            use it. More detail on the information we collect and how we do this is set out in our cookie policy.</li>
          <li>&nbsp;<strong>When you apply for a job to work at Sapia. </strong>When you enter into the recruitment
            process with us we may collect your name, contact details, recruitment information (e.g. right to work
            documentation and references), qualifications, accreditations, test results (inc. psychometric and coding) and any
            additional information we may receive from our recruitment partners.We will use your personal information to
            assess your suitability for our available roles. We do this to perform a contract or to take steps at your
            request, before entering into a contract. Where we process your right to work documentation, we will do so to
            comply with our legal obligations.</li>
          <li><strong>If our business is sold. </strong>We process your personal information for this purpose because we have
            a legitimate interest to ensure our business can be continued by the buyer. If you object to our use of your
            personal information in this way, the buyer of our business may not be able to provide services to you.</li>
        </ul>
      </p>
      <h3>Who do we share your data with?</h3>
      <p>
        <ul class="this-page-list">
          <li><strong>Business partners, suppliers, subcontractors and group companies </strong>for the performance of the
            contract we enter into with them or you.</li>
          <li><strong>Promotional events and marketing organisations</strong>, we do not sell data for marketing purposes, but
            may share your data with an event organiser including where we run workshops with co-presenters. We will always
            tell you before (usually on the event registration form) and you will be given the chance to opt-out before we do
            this.</li>
          <li><strong>Regulators/ Authorities/ Enforcement Agencies </strong>if we are under a duty to disclose or share your
            personal data in order to comply with any legal obligation, or in order to enforce or apply our terms of use and
            other agreements; or to protect the rights, property, or safety of our clients or others. This includes exchanging
            information with other companies and organisations for the purposes of fraud protection<strong>.</strong></li>
          <li><strong>Prospective buyers of our business</strong> under our legitimate interest to ensure our business can be
            continued by the buyer.</li>
        </ul>
      </p>
      <h3>Where is my data stored?</h3>
      <p>We store your data In country.</p>
      <p>Whenever we transfer your personal information outside of the UK and the EU, we ensure it receives additional
        protection as required by law. To keep this privacy notice as short and easy to understand as possible, we haven’t
        set out the specific circumstances when each of these protection measures are used. You can contact us at
        privacy@predictivehire.com for more detail on this.</p>
      <h3>How long do we keep your data for?</h3>
      <p>We will only retain your personal information for as long as we need it unless we are required to keep it for
        longer to comply with our legal, accounting or regulatory requirements.</p>
      <p>In some circumstances we may carefully anonymise your personal data so that it can no longer be associated with
        you, and we may use this anonymised information indefinitely without notifying you. We use this anonymised
        information to analyse our programmes and support other similar programmes around the world.</p>
      <h3>What are my rights under data protection laws?</h3>
      <p>You have various other rights under applicable data protection laws, including the right to:</p>
      <ul class="this-page-list">
        <li><strong>access</strong> your personal data (also known as a “subject access request”);</li>
        <li><strong>correct</strong> incomplete or inaccurate data we hold about you;</li>
        <li>ask us to <strong>erase</strong> the personal data we hold about you;</li>
        <li>ask us to <strong>restrict</strong> our handling of your personal data;</li>
        <li>ask us to <strong>transfer</strong> your personal data to a third party;</li>
        <li><strong>object</strong> to how we are using your personal data; and</li>
        <li><strong>withdraw</strong> your consent to us handling your personal data.</li>
      </ul>
      <p>You also have the right to lodge a complaint with your relevant supervisory authority, you can find which one
        applies to you <a target="_blank"
          href="https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm">here</a>.</p>
      <p>Please keep in mind that privacy law is complicated, and these rights will not always be available to you all of
        the time.</p>
      <h3>Questions, comments and more detail</h3>
      <p>Your feedback and suggestions on this notice are welcome.</p>
      <p>We’ve worked hard to create a notice that’s easy to read and clear. But if you feel that we have overlooked an
        important perspective or used language which you think we could improve, please let us know by email at
        privacy@predictivehire.com.</p>
      <p>This privacy notice was last updated on 26th May 2021.</p>
      <div class="candidate-inner-padding"></div>`,
      section_image: false,
    },
  ],
};
